// The firm's module switches: the catalogue with each row's state, which
// rows are on, and who saved them last. Admin-only on the server.

import type { FirmModulesResponse, FirmModulesUpdate } from "@duralex/shared";
import { getAuthHeaders } from "./auth";

async function modulesJson(res: Response): Promise<FirmModulesResponse> {
  if (!res.ok) {
    // A refusal names its reason ("2 installment plans still have parts
    // to issue"); the page shows that, not a status code.
    const body = (await res.json().catch(() => null)) as { error?: string } | null;
    throw new Error(body?.error ?? `Module settings request failed: ${res.status}`);
  }
  return (await res.json()) as FirmModulesResponse;
}

export async function fetchFirmModules(): Promise<FirmModulesResponse> {
  const res = await fetch("/api/firm/modules", {
    headers: { ...getAuthHeaders() },
    credentials: "same-origin",
  });
  return modulesJson(res);
}

export async function saveFirmModules(modules: FirmModulesUpdate): Promise<FirmModulesResponse> {
  const res = await fetch("/api/firm/modules", {
    method: "PUT",
    headers: { "Content-Type": "application/json", ...getAuthHeaders() },
    credentials: "same-origin",
    body: JSON.stringify({ modules }),
  });
  return modulesJson(res);
}
